import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import Logger from "../utils/logger";
import firebaseSettings, { getEmulatorConfig } from "../emulatorConfig";

// 環境に応じたFirebase設定
const useEmulator = firebaseSettings.isEmulator;

const firebaseConfig = useEmulator
  ? {
      // エミュレータ用の最小設定
      projectId: "ripuren-8609e",
      apiKey: "demo-key",
      authDomain: "demo-project.firebaseapp.com",
      storageBucket: "ripuren-8609e.firebasestorage.app",
    }
  : {
      // 本番用設定 - Firebase Console で確認した正しい値に更新してください
      apiKey: "AIzaSyDiQNWy8-Pm7oKOKJT2BRiFuLw0ZaAyCaw", // Firebase Console > プロジェクト設定 > 全般 から取得
      projectId: "ripuren-8609e",
      authDomain: "ripuren-8609e.firebaseapp.com",
      storageBucket: "ripuren-8609e.firebasestorage.app",
    };

// Firebase初期化
const app = initializeApp(firebaseConfig);

// Auth初期化
export const auth = getAuth(app);

// Firestore初期化
export const db = getFirestore(app);

// Storage初期化
export const storage = getStorage(app);

// エミュレーター接続（初期化直後に実行）
if (useEmulator) {
  const emulatorConfig = getEmulatorConfig();
  Logger.info("🔧 Connecting to Firebase emulators...");

  // Auth emulator
  connectAuthEmulator(auth, emulatorConfig.auth.httpUrl, { disableWarnings: true });
  Logger.info(`✅ Connected to Auth emulator at ${emulatorConfig.auth.url}`);

  // Firestore emulator
  connectFirestoreEmulator(db, emulatorConfig.firestore.host, emulatorConfig.firestore.port);
  Logger.info(`✅ Connected to Firestore emulator at ${emulatorConfig.firestore.url}`);

  // Storage emulator
  connectStorageEmulator(storage, emulatorConfig.storage.host, emulatorConfig.storage.port);
  Logger.info(`✅ Connected to Storage emulator at ${emulatorConfig.storage.url}`);
} else {
  Logger.info("🔥 Connected to production Firebase");
}

export default app;
